import GlobalConfig from "../../globalConfig";
import { getLocalstorage } from "../../helper";

export function getUploadAttachmentApiResponse(
  attachment,
  calculateUploadingPercentage,
  uploadAttachmentApiCallback
) {
  var http = new XMLHttpRequest();
  var url = GlobalConfig.getApiUrlFromRoot("/auth/fileManger/uploadFile");
  http.open("POST", url, true);
  const token = getLocalstorage("token");
  http.setRequestHeader("Authorization", "Bearer " + token);
  http.upload.onprogress = calculateUploadingPercentage;

  http.onreadystatechange = () => {
    uploadAttachmentApiCallback(http);
  };
  http.send(attachment);
}
